
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HotkeysService } from 'angular2-hotkeys';
import { ConfirmationService } from 'primeng/api';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { DashboardService } from 'src/app/Services/Dashboard/Dashboard.Service';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { ExportUtility } from 'src/assets/js/export-utility';


@Component({
  selector: 'app-v-prequote',
  templateUrl: './v-prequote.component.html',
  styleUrls: ['./v-prequote.component.css']
})
export class VPrequoteComponent implements OnInit {
  agentListGrid:any[]
  PreQuoteListGrid:any[];
  _IsProgressSpinner: boolean = false;
  cols:any[];
  constructor(private router: Router,private _CustomerinformationService: CustomerinformationService,private _DashboardService: DashboardService,private utility: CommonUtilities, private _hotkeysService: HotkeysService,
    private confirmationService: ConfirmationService
    ,private exportUtility: ExportUtility) { }

  ngOnInit(): void {
    this._IsProgressSpinner = true;
 this._CustomerinformationService.GetAllPreQuote().subscribe((result) => {
  this._IsProgressSpinner = false;
  const resultJSON = JSON.parse(JSON.stringify(result));
  if(resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined))
  {
    this.PreQuoteListGrid = resultJSON.lstPreQuoteView;
  }
  else{
    error => {

    }
  }
  //this.selectedrows = resultJSON.countryviews;
  //this._IsProgressSpinner = false;
  // this._Add = this._CountryService._Action._Add; 
  // this._delete = this._CountryService._Action._Delete;
  // this._update = this._CountryService._Action._Update;
  // this._View = this._CountryService._Action._View;
}, error => {  //this._IsProgressSpinner = false; 
});
}

exportExcel() {
let DashboardList = this.GetDashboardList();
this.exportUtility.exportExcel(DashboardList, 'Pre-Quote', 'xlsx');
}

ExportToPdf() {
let DashboardList = this.GetDashboardList();
this.exportUtility.ExportToPdf(DashboardList, 'Dashboard.pdf');
}


GetDashboardList() {
let DashboardList = [];
this.PreQuoteListGrid.forEach(element => {
  let Dashboard: any = {};
  Dashboard["Customer ID"] = element.customercode;
  Dashboard["Customer Name"] = element.customername;
  Dashboard["PAN"] = element.pan;
  Dashboard["Is Transporter"] = element.istransporter;
  Dashboard["Company Type"] = element.companytype;
  Dashboard["Billing Cycle"] = element.billingcycle;
  Dashboard["Pre-Quote Status"] = element.prequotestatus;
  //Dashboard["Remarks"] = element.modifiedon;
  Dashboard["Updated by"] = element.modifiedby;
  Dashboard["Updated On"] = element.modifiedon;      
  DashboardList.push(Dashboard);
});
return DashboardList;
}


  GoToCreate(event){
    
    this.router.navigate(['/prequote']);
  
}
ViewCustomerSite(event){
  // console.log(event);
  this.router.navigate(['/viewprequote'], { state: { sitecode: event.customersitecode} });
}
}
